import React from 'react';
import { observer } from 'mobx-react';
import { IPopoverProps, Position } from '@blueprintjs/core';
import { Popover } from 'core/components';

const DropdownMenu = ({ children, className, ...props }: IPopoverProps) => (
  <Popover position={Position.BOTTOM_RIGHT} popoverClassName={className} openOnTargetFocus minimal {...props}>
    {children}
  </Popover>
);

export default observer(DropdownMenu);
